/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography, breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const styles = {
  sectionTitle: () => css`
    .section-title {
      margin-bottom: var(--cds-spacing-200);
      ${breakpoints.down('sm')} {
        padding-left: var(--cds-spacing-300);
      }
    }
  `,
  sectionWrapper: () => css`
    margin-bottom: var(--cds-spacing-400);

    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-400);
    }
  `,
};

type PropsFromCaller = {
  title: string | React.ReactNode;
  customCss?: Interpolation<Theme>;
  children: React.ReactNode;
};

type Props = PropsFromCaller;

const ProfileSectionWithTitle = ({ title, children, customCss }: Props) => {
  return (
    <section css={[styles.sectionTitle, styles.sectionWrapper, customCss]}>
      <Typography variant="h1semibold" component="h2" className="section-title">
        {title}
      </Typography>
      {children}
    </section>
  );
};

export default ProfileSectionWithTitle;
